import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";

import {
  Alert,
  Collapse,
  Form,
  AutoComplete,
  Input,
  Row,
  Col,
  Select,
  Checkbox,
  Button,
  message,
  Radio,
  Spin,
  DatePicker,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";

import Navbar from "../../../atoms/navbar";

import "./styles.css";
import API from "../../../services";
import HeaderFarms from "../../../utils/header_farms";

import { loginRequest } from "../../../config/api.config";
import { requestToken } from "../../../auth/AuthServices";
import { sanitizePhoneNumber } from "../../../lib/utils";

import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Block, Confirm, Loading, Report } from "notiflix";

function CreateServiceRequest() {
  const [form] = Form.useForm();
  const typeRequestValue = Form.useWatch("type_request", form);
  const isDroneRequest = typeRequestValue === "Request Drone";

  const { Panel } = Collapse;
  const { TextArea } = Input;

  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();

  //auto complete username
  const [options, setOptions] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [applications, setApplications] = useState([]);

  const [typeRequestExplain, setTypeRequestExplain] = useState(true);
  const [justification, setJustification] = useState(true);
  const [EquipmentDetails] = useState(true);

  const [equipmentDetails, setEquipmentDetails] = useState(false);
  const [networkFolder, setNetworkFolder] = useState(false);
  const [permission, setPermission] = useState(false);
  const [isUserRequired, setIsUserRequired] = useState(false);

  // Refs untuk debounce Graph API
  const debounceTimerRef = useRef(null);
  const graphCacheRef = useRef(new Map());

  const [hiddenLoginName, setHiddenLoginName] = useState(true);
  const [hiddenEmailAddress, setHiddenEmailAddress] = useState(true);

  const [loginNameValid, setLoginNameValid] = useState({
    validateStatus: null,
    help: null,
  });

  const [otherChecked, setOtherChecked] = useState(false);
  const [otherSystem, setOtherSystem] = useState("");

  const [otherAccountChecked, setOtherAccountChecked] = useState(false);
  const [otherAccount, setOtherAccount] = useState("");

  const [employeeStatus, setEmployeeStatus] = useState(null);
  const [dataReady, setDataReady] = useState(false);
  const [activePanels, setActivePanels] = useState(["0", "1", "2", "2b", "3", "4", "5", "drone"]);

  // Master data dari backend (sebelumnya hardcoded)
  const [accountOptions, setAccountOptions] = useState([]);
  const [typeRequestOptions, setTypeRequestOptions] = useState([]);
  const [equipmentOptions, setEquipmentOptions] = useState([]);

  // Refresh state untuk requestor (Talenta data)
  const [refreshing, setRefreshing] = useState(false);

  const handleOtherAccountChange = (e) => {
    setOtherAccount(e.target.value);
  };

  const handleOtherCheckboxChange = (e) => {
    setOtherChecked(e.target.checked);
  };

  const handleOtherSystemChange = (e) => {
    setOtherSystem(e.target.value);
  };

  const changeTypeRequest = () => {
    form.setFieldsValue({
      equipment_details: [],
      equipment_details_explain: null,
      account_request: null,
      account_request_other: null,
      system_request: [],
      system_request_other: null,
      justification: null,
      login_name: null,
      network_folder: null,
      permission_network_folder: [],
      communication_access: [],
      description: null,
      drone_area: null,
      drone_request_at: null,
    });
  };

  const navigate = useNavigate();

  const onSelectName = async (value) => {

    const selectedOption = options.find((option) => option.value === value);
    const detailData = selectedOption.detail;

    form.setFieldsValue({
      position: detailData.job_position,
      department: detailData.organization_name,
      phone_number: sanitizePhoneNumber(detailData.mobile_phone),
      company: detailData.branch_name,
      employee_id: detailData.employee_id,
      employee_status: detailData.employment_status,
      branch_nickname: detailData.branch_nickname,
      account_request: null
    });


    setHiddenLoginName(true)
    setHiddenEmailAddress(true)

    await AutoChecklist()
  };

  const changeEmployeeStatus = (event) => {
    const value = event.target.value;
    setEmployeeStatus(value);

    form.setFieldsValue({
      fullname: null,
      position: null,
      department: null,
      phone_number: null,
      company: null,
      employee_id: null,
      // Hidden field employee_status mengikuti radio. Backend cek === "Non Employee".
      // Untuk Employee, akan ditimpa onSelectName dari Talenta (Permanent/Contract).
      employee_status: value === "Non Employee" ? "Non Employee" : null,
    });
  };

  const getDepartment = async (token) => {
    try {
      const res = await API.SROrganizations(HeaderFarms(token));

      const DTO = [];

      res.data.forEach((i) => {
        DTO.push({
          id: i.id,
          name: i.name,
        });
      });

      setDepartments(DTO);
    } catch (err) {
      console.log(err);
      message.warning("Terjadi Kesalahan saat load data department");
    }
  };

  const getApplications = async (token) => {
    try {
      const res = await API.getApplications(HeaderFarms(token), null);

      const DTO = [];

      res.data.forEach((i) => {
        DTO.push({
          id: i.app_id,
          name: i.name,
        });
      });

      setApplications(DTO);
    } catch (err) {
      console.log(err);
      message.warning("Terjadi Kesalahan saat load data application");
    }
  };

  const fetchMasterAccount = async (token) => {
    try {
      const res = await API.SRAccountList(HeaderFarms(token));
      setAccountOptions((res.data || []).map((i) => ({ value: i.name, label: i.name })));
    } catch (err) {
      console.log(err);
      message.warning("Terjadi Kesalahan saat load data account");
    }
  };

  const fetchMasterTypeRequest = async (token) => {
    try {
      const res = await API.SRTypeRequestList(HeaderFarms(token));
      setTypeRequestOptions((res.data || []).map((i) => ({ value: i.name, label: i.name })));
    } catch (err) {
      console.log(err);
      message.warning("Terjadi Kesalahan saat load data type request");
    }
  };

  const fetchMasterEquipment = async (token) => {
    try {
      const res = await API.SREquipmentList(HeaderFarms(token));
      setEquipmentOptions((res.data || []).map((i) => ({ value: i.name, label: i.name })));
    } catch (err) {
      console.log(err);
      message.warning("Terjadi Kesalahan saat load data equipment");
    }
  };

  const AILoginName = async (requestorDetail) => {
    
    try {

      if (!requestorDetail?.fullname || !requestorDetail?.branch_nickname) {
        return { loginName: null, emailAddress: null };
      }

      const domainName = getDomainByBranch(requestorDetail.branch_nickname);

      if (!domainName) {
        throw new Error(`Domain tidak ditemukan untuk branch: ${requestorDetail.branch_nickname}`);
      }

      const cleanFullName = requestorDetail.fullname.replace(/\(\d+\)/g, "").trim();

      if (!cleanFullName) return { loginName: null, emailAddress: null };

      const splitFullName = cleanFullName.toLowerCase().split(" ");

      const firstName = splitFullName[0];

      const lastName = splitFullName.length > 1 ? splitFullName[splitFullName.length - 1] : null;

      // Email sesuai jumlah kata
      const emailAddress = lastName
        ? `${firstName}.${lastName}@${domainName}`
        : `${firstName}@${domainName}`;

      // Logic loginName tetap pakai firstNameStack
      const sendApi = [];

      let firstNameStack = "";

      for (const char of firstName) {
        firstNameStack += char;
        sendApi.push(`${firstNameStack}${lastName ? lastName : ""}@${domainName}`);
      }

      const response = await getUser365toMicrosoftGraph(sendApi[0]);

      let loginName;

      if (response?.value?.length) {

        const foundIndex = sendApi.indexOf(response.value[0].userPrincipalName);
        loginName = sendApi[foundIndex + 1] || sendApi[0];

      } else {  
        

        loginName = splitFullName.length > 1 ? sendApi[0] : `${firstName}@${domainName}`;

      }

      return { loginName, emailAddress };

    } catch (error) {

      console.error(error);
      message.warning("Terjadi Kesalahan saat AI Login Name");
      return { loginName: null, emailAddress: null };
    }

    function getDomainByBranch(branch_nickname) {
      const domainMap = {
        BRM: 'brm.co.id',
        CPM: 'citrapalu.com',
        GMI: 'gorontalominerals.com',
        SHS: 'shsinergi.com',
        LMR: 'lingemineral.com',
      };
      return domainMap[branch_nickname?.toUpperCase()] || null;
    }
  };


  const AutoChecklist = async (FormValues, event) => {

    try {

      if (!FormValues?.fullname) return

      const { loginName, emailAddress } = await AILoginName({
        fullname: FormValues.fullname,
        branch_nickname: FormValues.branch_nickname
      })

      if (event.target.value === "Email") {
        if (FormValues.account_request.includes("Email")) {
          form.setFieldsValue({
            account_request: ["Email", "Internet Access", "AD / FARMS"],
            login_name: loginName,
            email_address: emailAddress
          });
        }
      }

    } catch (error) {
      message.warning("Error in AutoChecklist:", error);
    }

    JusticationCheck(FormValues);
  };


  const chackCustomLoginName = (e) => {
    const value = e.target.value?.trim();

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    if (!value || value.length < 3) {
      setLoginNameValid({ validateStatus: null, help: null });
      return;
    }

    // Cek cache: hasil validasi yang sama tidak perlu fetch ulang
    if (graphCacheRef.current.has(value)) {
      setLoginNameValid(graphCacheRef.current.get(value));
      return;
    }

    setLoginNameValid({
      validateStatus: "validating",
      help: "The login name is being validated...",
    });

    debounceTimerRef.current = setTimeout(async () => {
      try {
        const response = await getUser365toMicrosoftGraph(value);
        const result = response?.value?.length > 0
          ? { validateStatus: "error", help: "Login name already used" }
          : { validateStatus: "success", help: "Login name can be used" };

        graphCacheRef.current.set(value, result);
        setLoginNameValid(result);
      } catch (error) {
        console.error(error);
        message.warning("Terjadi Kesalahan saat check login name");
      }
    }, 400);
  };

  const getUser365toMicrosoftGraph = async (filterName) => {
    try {
      const request = {
        ...loginRequest,
        account: accounts[0],
      };

      const getToken = await instance.acquireTokenSilent(request);

      const response = await fetch(
        `https://graph.microsoft.com/v1.0/users?$select=userPrincipalName&$filter=startswith(userPrincipalName,'${filterName}')`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken.accessToken}`,
          },
        }
      );

      return response.json();
    } catch (error) {
      console.error(error);
      message.warning("Terjadi Kesalahan saat validasi username 365");
    }
  };

  const createServiceRequest = (data, token) => {

    const cleanFullName = data.fullname.replace(/\(\d+\)/g, "").trim();
    data.fullname = cleanFullName;

    API.SRNewRequest(HeaderFarms(token), data)
      .then((res) => {

        Loading.remove()
        Report.success(
          `The request was successfully`,
          "Thankyou, We will immediately process your request",
          "Okay",
          function () {
            navigate("/sr/history");
          }
        );
        Loading.remove();
      })
      .catch((err) => {
        console.error(err);

        const title = "Oops.. something went wrong";
        let message = "Sorry, this application is experiencing problems";

        // Cek jika status code 404
        if (err?.response?.status === 404) {
          const errorDetail = err.response?.data?.error?.[0]?.name;
          if (errorDetail) {
            message = errorDetail;
          }
        }

        Report.warning(title, message, "Okay");
        Loading.remove();
      });
  };

  const onFinish = async (values) => {

    const accessToken = await requestToken();
    if (!accessToken) return;

    const isDrone = values.type_request === "Request Drone";

    // Skip Graph check kalau drone (login_name tidak ada di drone request)
    if (!isDrone && values.login_name) {
      const response = await getUser365toMicrosoftGraph(values.login_name);
      if (response?.value?.length > 0) {
        message.warning("Login name sudah tersedia.");
        return false;
      }
    }

    Confirm.show(
      "Important Confirmation",
      "Are you sure ? Please make sure your request is correct.",
      "Yes",
      "No",
      () => {

        const result = values;

        result.fullname = result.fullname.split("-")[0];

        // equipment_details bisa undefined saat drone request
        result.equipment_details = Array.isArray(result.equipment_details)
          ? result.equipment_details.join(" | ")
          : (result.equipment_details || null);

        // Convert drone_request_at moment → ISO string
        if (result.drone_request_at && typeof result.drone_request_at.toISOString === "function") {
          result.drone_request_at = result.drone_request_at.toISOString();
        }

        Object.keys(result).forEach((key) => {
          if (result[key] === undefined) {
            result[key] = null;
          }
        });

        try {
          Loading.dots("Processing your request...");

          createServiceRequest(result, accessToken);
        } catch (error) {
          navigate("/");
          console.error("Error creating service request:", error);
        }
      }
    );
  };

  const onChangeCollapse = (key) => { };

  const handlePhoneNumberChange = (e) => {
    let value = e.target.value;

    if (value === "0") {
      value = "62";
    }

    // Remove any non-numeric characters
    value = value.replace(/\D/g, "");

    form.setFieldsValue({
      phone_number: value,
    });
  };

  const typeRequestHandler = (e) => {
    if (!e) return;

    // Reset visibility/required state
    setEquipmentDetails(false);
    setNetworkFolder(false);
    setPermission(false);
    setTypeRequestExplain(e !== "Other");

    changeTypeRequest();
    setHiddenLoginName(true);
    setJustification(true);
    setOtherChecked(false);
    setOtherAccountChecked(false);
  };

  const JusticationCheck = (FormValues) => {
    // if checked email to be sure need internet access
    if (
      FormValues.account_request.includes("Internet Access") ||
      FormValues.account_request.includes("Email")
    ) {
      setJustification(false);
    } else {
      setJustification(true);
    }
  };

  const AccountRequestHandler = async (event) => {

    const FormValues = form.getFieldValue();

    const hasOtherAccountRequest = FormValues.account_request.includes("Other");
    setOtherAccountChecked(hasOtherAccountRequest);

    const requiresLoginName = FormValues.account_request.includes("AD / FARMS");
    const requiresEmailAddress = FormValues.account_request.includes("Email");


    setHiddenLoginName(!requiresLoginName);

    if (event.target.value === 'Email') {
      setHiddenEmailAddress(!requiresEmailAddress)
      setHiddenLoginName(false)
    }

    JusticationCheck(FormValues);

    AutoChecklist(FormValues, event);
  };

  const PermissionNetworkFolderHandler = (event) => {

    if (event.includes("Full Access")) {
      form.setFieldsValue({
        permission_network_folder: [
          "Full Access",
          "Modifiy / Write",
          "Read Only",
        ],
      });
    } else {
      form.setFieldsValue({
        permission_network_folder: event,
      });
    }
    setIsUserRequired(event.length > 0);

  };

  const InformationNoted = () => {
    return (
      <>
        <ul className="note-sr">
          <li>
            By submitting this form, the user agrees to be responsible for the
            security, operation, and cost of the requested service(s)
          </li>
          <li>
            IT Div. will review the justification and technical aspects of the
            request. IT Div. may decline the request, and will advise the
            requestor
          </li>
          <li>
            All details must be completed in full or request will not be
            approved.
          </li>
          <li>Must specify the expiry date for non/Temporary employee</li>
        </ul>
      </>
    );
  };

  async function getUsersBasedOnBranch(token, refresh = false) {
    try {
      const res = await API.SRRequestors(HeaderFarms(token), { refresh });
      const requestors = res?.data || [];

      const filter = requestors.map((employee) => ({
        value: `${employee.fullname.trim()} (${employee.employee_id})`,
        label: `${employee.fullname.trim()} (${employee.employee_id})`,
        key: employee.id_row,
        detail: employee,
      }));

      setOptions(filter);
    } catch (error) {
      console.error(error);
    }
  }

  const handleRefreshRequestor = async () => {
    setRefreshing(true);
    try {
      const accessToken = await requestToken(instance, accounts[0]);
      if (!accessToken) return;
      await getUsersBasedOnBranch(accessToken, true);
      message.success("Data requestor di-refresh dari Talenta");
    } catch (error) {
      console.error(error);
      message.warning("Gagal refresh data requestor");
    } finally {
      setRefreshing(false);
    }
  };

  function handleLogin(instance) {
    instance
      .loginRedirect(loginRequest)
      .then(() => { })
      .catch((e) => {
        console.error(e);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      setDataReady(false);
      try {
        const accessToken = await requestToken(instance, accounts[0]);
        if (!accessToken) {
          return;
        }
        await Promise.all([
          getUsersBasedOnBranch(accessToken),
          getApplications(accessToken),
          getDepartment(accessToken),
          fetchMasterAccount(accessToken),
          fetchMasterTypeRequest(accessToken),
          fetchMasterEquipment(accessToken),
        ]);
      } catch (error) {
        handleLogin(instance);
        console.error("Error requesting token:", error);
      } finally {
        setDataReady(true);
      }
    };
    fetchData();
  }, [isAuthenticated]);

  // Cleanup debounce timer saat unmount supaya tidak fire setelah component lepas
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  return (
    <>
      <Navbar
        title="Create"
        back={true}
        subtitle="Service Request"
        navigate="/sr/history"
       />
      <div className="container-fluid white-back-cr">
        {!dataReady && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: 400,
              gap: 16,
              color: "#8c8c8c",
            }}
          >
            <Spin size="large" />
            <div style={{ fontSize: 13 }}>Loading form data...</div>
          </div>
        )}
        <div style={{ display: dataReady ? "block" : "none" }}>
        <Form
          form={form}
          name="service_request_form"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={() => message.warning("Mohon lengkapi formulir.")}
          autoComplete="off"
          size="small"
          layout="vertical"
        >
          <div className="container p-3" style={{ alignSelf: "center" }}>
            <div className="row">
              <div className="col-md-12">
                <Collapse
                  className="collapse_sr"
                  expandIconPosition={"end"}
                  bordered={false}
                  activeKey={activePanels}
                  onChange={(keys) => {
                    const arr = Array.isArray(keys) ? keys : [keys];
                    setActivePanels(arr);
                    if (typeof onChangeCollapse === "function") onChangeCollapse(arr);
                  }}
                >
                  <Panel
                    style={{ background: "#fce8b6" }}
                    header={<b>User Requiring Access</b>}
                    key="1"
                  >
                    <Row gutter={10} className="mb-1">
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Status Employee"
                          name={"employee_status_first"}
                          rules={[
                            { required: true, message: "Please input Status" },
                          ]}
                        >
                          <Radio.Group onChange={changeEmployeeStatus}>
                            <Radio value="Employee">Employee</Radio>
                            <Radio value="Non Employee">Non Employee</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={10} className="mb-1">
                      {employeeStatus === "Employee" ? (
                        <Col
                          xs={{ span: 23 }}
                          sm={{ span: 7 }}
                          xl={{ span: 7 }}
                        >
                          <Form.Item
                            className="loading"
                            label={
                              <span style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                <span>Fullname</span>
                                <Button
                                  type="link"
                                  size="small"
                                  icon={<ReloadOutlined spin={refreshing} />}
                                  onClick={handleRefreshRequestor}
                                  loading={refreshing}
                                  style={{ padding: 0, height: "auto", fontSize: 11 }}
                                >
                                  Refresh
                                </Button>
                              </span>
                            }
                            name="fullname"
                            extra="* Data diambil dari Talenta. Jika belum update, tunggu hingga 1 jam."
                            rules={[
                              {
                                required: true,
                                message: "Please input fullname",
                              },
                            ]}
                          >
                            <Select
                              showSearch
                              size="middle"
                              placeholder="Pilih nama"
                              optionFilterProp="children"
                              onSelect={onSelectName}
                              filterOption={(inputValue, option) =>
                                option.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                              }
                            >
                              {options.map((option) => (
                                <Select.Option key={option.value} value={option.value}>
                                  {option.label}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>

                        </Col>
                      ) : (
                        <Col
                          xs={{ span: 23 }}
                          sm={{ span: 7 }}
                          xl={{ span: 7 }}
                        >
                          <Form.Item
                            className="loading"
                            label="Fullname"
                            name="fullname"
                            rules={[
                              {
                                required: true,
                                message: "Please input fullname",
                              },
                            ]}
                          >
                            <Input placeholder="Rinaldi Kautsar" />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                    <Row gutter={10}>
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Position"
                          name="position"
                          rules={[
                            {
                              required: true,
                              message: "Please input Position",
                            },
                          ]}
                        >
                          <Input placeholder="Staff - IT Support" />
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 23 }} sm={{ span: 8 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Department"
                          name="department"
                          rules={[
                            {
                              required: false,
                              message: "Please input Department",
                            },
                          ]}
                        >
                          <AutoComplete
                            placeholder="Select Department"
                            filterOption={(inputValue, option) =>
                              option.value
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                          >
                            {departments.map((department) => (
                              <AutoComplete.Option
                                key={department.id}
                                value={department.name}
                              >
                                {department.name}
                              </AutoComplete.Option>
                            ))}
                          </AutoComplete>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={10}>
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Employee ID"
                          name="employee_id"
                          rules={[
                            {
                              required: true,
                              message: "Please input Employee ID",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Employee ID / NIK"
                            onKeyPress={(e) => {
                              if (e.which < 48 || e.which > 57) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>

                      {/* Branch NickName */}
                      <Form.Item name="branch_nickname" hidden>
                        <Input type="hidden" />
                      </Form.Item>

                      <Col xs={{ span: 23 }} sm={{ span: 8 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Business Unit"
                          name="company"
                          rules={[
                            {
                              required: true,
                              message: "Please select business unit",
                            },
                          ]}
                        >
                          <Select placeholder="Select Business Unit" readOnly>
                            <Select.Option value="Bumi Resources Minerals">
                              Bumi Resources Minerals
                            </Select.Option>
                            <Select.Option value="Citra Palu Minerals">
                              Citra Palu Minerals
                            </Select.Option>
                            <Select.Option value="Gorontalo Minerals">
                              Gorontalo Minerals
                            </Select.Option>
                            <Select.Option value="Linge Mineral Resources">
                              Linge Mineral Resources
                            </Select.Option>
                            <Select.Option value="Dairi Prima Minerals">
                              Dairi Prima Minerals
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={10}>
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Phone"
                          name="phone_number"
                          rules={[
                            { required: false, message: "Please input phone" },
                          ]}
                        >
                          <Input
                            placeholder="example: 628597721233"
                            inputMode="numeric"
                            pattern="[0-9]*"
                            onChange={handlePhoneNumberChange}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Employee Status"
                          name="employee_status"
                          rules={[
                            { required: true, message: "Please input status" },
                          ]}
                        >
                          <Select>
                            <Select.Option value="Contract">
                              Contract
                            </Select.Option>
                            <Select.Option value="Permanent">
                              Permanent
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Panel>
                  <Panel
                    style={{ background: "#fce8b6" }}
                    header={<b>Request Type</b>}
                    key="2"
                  >
                    <Row className="mt-3" gutter={20}>
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Type of Request"
                          name="type_request"
                          rules={[
                            {
                              required: true,
                              message: "Please input type request",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select"
                            onChange={typeRequestHandler}
                            options={typeRequestOptions}
                          />
                        </Form.Item>
                        <Form.Item
                          label={
                            <span>
                              Type Request&nbsp;
                              <em style={{ fontStyle: "italic", fontSize: 10 }}>
                                ( Please explain )
                              </em>
                            </span>
                          }
                          name="type_request_explain"
                          hidden={typeRequestExplain}
                          rules={[
                            {
                              required: !typeRequestExplain,
                              message: "Please input type explain",
                            },
                          ]}
                        >
                          <TextArea rows={2} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Panel>
                  {isDroneRequest && (
                    <Panel
                      style={{ background: "#fce8b6" }}
                      header={<b>Drone Request</b>}
                      key="drone"
                    >
                      <Row className="mt-3" gutter={20}>
                        <Col xs={{ span: 23 }} sm={{ span: 14 }} xl={{ span: 14 }}>
                          <Form.Item
                            label="Area"
                            name="drone_area"
                            rules={[
                              {
                                required: isDroneRequest,
                                message: "Please input area",
                              },
                            ]}
                          >
                            <Input placeholder="Contoh: Pit Selatan blok 3" />
                          </Form.Item>
                        </Col>
                        <Col xs={{ span: 23 }} sm={{ span: 8 }} xl={{ span: 8 }}>
                          <Form.Item
                            label="Tanggal & Jam Pelaksanaan"
                            name="drone_request_at"
                            rules={[
                              {
                                required: isDroneRequest,
                                message: "Please pick date & time",
                              },
                            ]}
                          >
                            <DatePicker
                              showTime={{ format: "HH:mm" }}
                              format="YYYY-MM-DD HH:mm"
                              style={{ width: "100%" }}
                              placeholder="Select date & time"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Panel>
                  )}
                  {!isDroneRequest && (
                    <Panel
                      style={{ background: "#fce8b6" }}
                      header={<b>Equipment Request</b>}
                      key="2b"
                    >
                      <Row className="mt-3" gutter={20}>
                        <Col xs={{ span: 23 }} sm={{ span: 14 }} xl={{ span: 14 }}>
                          <Form.Item
                            label="Equipment"
                            name="equipment_details"
                            rules={[
                              {
                                required: equipmentDetails,
                                message: "Please input Equipment Details",
                              },
                            ]}
                          >
                            <Select
                              size="middle"
                              placeholder="Select"
                              allowClear={true}
                              mode="multiple"
                              options={equipmentOptions}
                            />
                          </Form.Item>
                          <Form.Item
                            label={
                              <span>
                                Equipment Other&nbsp;
                                <em style={{ fontStyle: "italic", fontSize: 10 }}>
                                  ( Please explain )
                                </em>
                              </span>
                            }
                            name="equipment_details_explain"
                            hidden={!EquipmentDetails}
                            rules={[
                              {
                                required: !EquipmentDetails,
                                message: "Please input type explain",
                              },
                            ]}
                          >
                            <TextArea rows={2} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Panel>
                  )}
                  {!isDroneRequest && (
                  <Panel
                    style={{ background: "#fce8b6" }}
                    header={<b>System Request</b>}
                    key="3"
                  >
                    <Row gutter={10}>
                      <Col
                        xs={{ span: 23 }}
                        sm={{ span: 12 }}
                        xl={{ span: 12 }}
                      >
                        <Form.Item
                          className="mt-4"
                          label={<b>Account</b>}
                          name="account_request"
                          rules={[
                            {
                              // required: accountRole,
                              required: false,
                              message: "Please input account",
                            },
                          ]}
                        >
                          <Checkbox.Group>
                            <Row>
                              {accountOptions
                                .filter((opt) => opt.value !== "Other")
                                .map((opt) => (
                                  <Col onChange={AccountRequestHandler} span={12} key={opt.value}>
                                    <Checkbox value={opt.value}>{opt.label}</Checkbox>
                                  </Col>
                                ))}
                              <Col onChange={AccountRequestHandler} span={12}>
                                <Checkbox value="Other">Other</Checkbox>
                                {otherAccountChecked && (
                                  <Form.Item
                                    label={
                                      <em
                                        style={{ fontSize: 10, marginTop: 10 }}
                                      >
                                        (Please Explain)
                                      </em>
                                    }
                                    name="account_request_other"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please input account",
                                      },
                                    ]}
                                  >
                                    <TextArea
                                      rows={2}
                                      placeholder="Please input other account"
                                      value={otherAccount}
                                      onChange={handleOtherAccountChange}
                                    />
                                  </Form.Item>
                                )}
                              </Col>
                            </Row>
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={10}>
                      <Col
                        xs={{ span: 23 }}
                        sm={{ span: 12 }}
                        xl={{ span: 12 }}
                      >
                        <Form.Item
                          className="mt-4"
                          label={<b>System</b>}
                          name="system_request"
                          rules={[
                            {
                              required: false,
                              message: "Please input system",
                            },
                          ]}
                        >
                          <Checkbox.Group>
                            <Row>
                              {applications.map((item) => (
                                <Col span={12} key={item.id}>
                                  <Checkbox value={item.id}>
                                    {item.name}
                                  </Checkbox>
                                </Col>
                              ))}
                              <Col span={12}>
                                <Checkbox
                                  value={"Other"}
                                  onChange={handleOtherCheckboxChange}
                                >
                                  Other
                                </Checkbox>
                                {otherChecked && (
                                  <Form.Item
                                    label={
                                      <em
                                        style={{ fontSize: 10, marginTop: 10 }}
                                      >
                                        (Please Explain)
                                      </em>
                                    }
                                    name="system_request_other"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Please input system",
                                      },
                                    ]}
                                  >
                                    <TextArea
                                      rows={2}
                                      placeholder="Please input other system"
                                      value={otherSystem}
                                      onChange={handleOtherSystemChange}
                                    />
                                  </Form.Item>
                                )}
                              </Col>
                            </Row>
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row className="mt-3" gutter={10}>
                      <Col xs={{ span: 23 }} span={12}>
                        <Form.Item
                          label={
                            <>
                              <span style={{ fontSize: 11 }}>
                                Justication ( Why internet acces required and/or
                                why additional new access point is required ? ){" "}
                              </span>
                            </>
                          }
                          name="justification"
                          hidden={justification}
                          rules={[
                            {
                              required: !justification,
                              message: "Please input type explain",
                            },
                          ]}
                        >
                          <TextArea rows={4} className="" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Panel>
                  )}
                  {!isDroneRequest && (
                  <Panel
                    style={{ background: "#fce8b6" }}
                    header={<b>Network Access and Communication Request</b>}
                    key="4"
                  >
                    <Row gutter={10}>
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Login Name"
                          name="login_name"
                          extra="* Please custom login name and email if not suitable"
                          help={loginNameValid.help}
                          hidden={hiddenLoginName}
                          validateStatus={loginNameValid.validateStatus}
                          rules={[
                            {
                              required: false,
                              message: "Please input login name",
                            },
                          ]}
                        >
                          <Input onChange={chackCustomLoginName} />
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 23 }} sm={{ span: 7 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Email Address"
                          name="email_address"
                          hidden={hiddenEmailAddress}
                          rules={[
                            {
                              required: false,
                              message: "Please input email address",
                            },
                          ]}
                        >
                          <Input />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={20} className="mt-3">
                      <Col xs={{ span: 20 }} sm={{ span: 10 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Network Folder / File Path"
                          name="network_folder"
                          rules={[
                            {
                              required: networkFolder,
                              message: "Please input network folder",
                            },
                          ]}
                        >
                          <Input placeholder="Example : HSE or Legal" />
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 20 }} sm={{ span: 10 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Permissions"
                          name="permission_network_folder"
                          rules={[
                            {
                              required: permission,
                              message: "Please input network folder",
                            },
                          ]}
                        >
                          <Checkbox.Group
                            onChange={PermissionNetworkFolderHandler}
                          >
                            <Row>
                              <Col>
                                <Checkbox value="Full Access">
                                  Full Access
                                </Checkbox>
                              </Col>
                              <Col>
                                <Checkbox value="Modifiy / Write">
                                  Modifiy /Write
                                </Checkbox>
                              </Col>
                              <Col>
                                <Checkbox value="Read Only">Read Only</Checkbox>
                              </Col>
                            </Row>
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                      <Col xs={{ span: 24 }} sm={{ span: 10 }} xl={{ span: 7 }}>
                        <Form.Item
                          className="loading"
                          label="Select Approver ( Permit Folder Access )"
                          name="additional_approver_label"
                          rules={[
                            {
                              required: isUserRequired,
                              message: "Please select user",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            size="middle"
                            placeholder="Select User"
                            filterOption={(inputValue, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(inputValue.toLowerCase()) >= 0
                            }
                            onChange={(selectedValue) => {
                              const selectedOption = options.find(
                                (option) => option.value === selectedValue
                              );

                              if (selectedOption) {
                                const employeeId =
                                  selectedOption.detail.employee_id;
                                form.setFieldsValue({
                                  additional_approver: employeeId,
                                });
                              }
                            }}
                          >
                            {options.map((option) => (

                              <Select.Option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item name="additional_approver" hidden>
                          <Input type="hidden" />
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row gutter={20}>
                      <Col xs={{ span: 24 }} sm={{ span: 10 }} xl={{ span: 7 }}>
                        <Form.Item
                          label="Communication Access"
                          name="communication_access"
                          rules={[
                            {
                              required: false,
                              message: "Please input communication access",
                            },
                          ]}
                        >
                          <Checkbox.Group onChange={null}>
                            <Row>
                              <Col span={12}>
                                <Checkbox value="Extension Phone">
                                  Extension Phone
                                </Checkbox>
                              </Col>
                              <Col span={12}>
                                <Checkbox value="GSM">GSM</Checkbox>
                              </Col>
                              <Col span={12}>
                                <Checkbox value="Internet Data Package">
                                  Internet Data Package
                                </Checkbox>
                              </Col>
                            </Row>
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Panel>
                  )}
                  <Panel
                    style={{ background: "#fce8b6" }}
                    header={<b>Description</b>}
                    key="5"
                  >
                    <Row gutter={10}>
                      <Col xs={{ span: 23 }} span={12}>
                        <Form.Item
                          label={
                            <>
                              <span>
                                Description ( Brief description of the
                                requirements & justification )
                              </span>
                            </>
                          }
                          name="description"
                          rules={[
                            {
                              // required: description,
                              required: true,
                              message:
                                "Please input Brief description of the requirements & justification",
                            },
                          ]}
                        >
                          <TextArea rows={4} className="mt-3" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Panel>
                </Collapse>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12">
                <Alert
                  message="Informational Notes"
                  description={<InformationNoted />}
                  type="info"
                  showIcon
                  className="note-sr"
                />
              </div>
            </div>
          </div>
          <Row className="justify-content-center">
            <Col>
              <Form.Item>
                <Button type="primary" size="middle" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        </div>
      </div>
    </>
  );
}
export default CreateServiceRequest;
